// removed by extract-text-webpack-plugin
module.exports = {"menuFocusTrap":"menuFocusTrap__2dgiM"};


//////////////////
// WEBPACK FOOTER
// ./components/header/style.css
// module id = u3et
// module chunks = 7